.tabsWrap {
  position: relative;
  margin-bottom: var(--space-4);
}

.tabs {
  position: relative;
  display: flex;
  gap: var(--space-1);
  border-bottom: 1px solid var(--border);
  overflow-x: auto;
  scrollbar-width: none;
}

/* Er staan nog tabs rechts buiten beeld: zachte rand (geen knop, gewoon vegen of Tab). */
.fade {
  position: absolute;
  top: 0;
  inset-inline-end: 0;
  bottom: 1px;
  width: 40px;
  background: linear-gradient(to left, var(--surface-canvas), var(--surface-canvas-clear));
  pointer-events: none;
}

.tabs::-webkit-scrollbar {
  display: none;
}

.tab {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  min-height: var(--b-touch);
  padding: 0 var(--b-space-12);
  border: 0;
  background: transparent;
  color: var(--text-muted);
  font: inherit;
  font-size: var(--b-text-body);
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
}

.tab:hover {
  color: var(--text);
}

.tab:focus-visible {
  outline: 3px solid var(--focus-ring);
  outline-offset: -3px;
  border-radius: var(--radius-sm);
}

.tab::after {
  content: '';
  position: absolute;
  left: var(--space-3);
  right: var(--space-3);
  bottom: -1px;
  height: 3px;
  border-radius: 3px 3px 0 0;
  background: var(--accent);
  opacity: 0;
  transform: scaleX(0.6);
  transition:
    opacity var(--dur) var(--ease-out),
    transform var(--dur) var(--ease-out);
}

.selected {
  color: var(--text);
}

.selected::after {
  opacity: 1;
  transform: none;
}

.count {
  min-width: 22px;
  height: 22px;
  padding: 0 8px;
  border-radius: var(--radius-pill);
  background: var(--accent-tint);
  color: var(--accent);
  font-size: var(--b-text-meta);
  line-height: 22px;
  text-align: center;
}

/* RTL (golf 3): de zachte rand staat links, het verloop draait mee. */
[dir='rtl'] .fade {
  background: linear-gradient(to right, var(--surface-canvas), var(--surface-canvas-clear));
}

/* Telefoon: kleinere letter en minder lucht, zodat vier korte tabs (Eten) op 360 px passen; past
   het niet, dan scrollt de rij met de zachte rand (WP1: geen pictogramkolommen meer). */
@media (max-width: 599.98px) {
  .tabsWrap {
    margin-bottom: var(--b-space-12);
  }

  .tabs {
    gap: 0;
  }

  .tab {
    flex: 1 0 auto;
    justify-content: center;
    padding: 0 var(--b-space-8);
    font-size: var(--b-text-small);
  }

  .tab::after {
    left: 8px;
    right: 8px;
  }
}
